import { render, staticRenderFns } from "./PreviewOrganiserEmail.vue?vue&type=template&id=608d6313&scoped=true"
import script from "./PreviewOrganiserEmail.vue?vue&type=script&lang=js"
export * from "./PreviewOrganiserEmail.vue?vue&type=script&lang=js"
import style0 from "./PreviewOrganiserEmail.vue?vue&type=style&index=0&id=608d6313&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608d6313",
  null
  
)

export default component.exports